import { DefaultValue, getShadow, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const DatePeriodChooserButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
`

interface DatePeriodChooserWrapperProps {
  open: boolean
}

export const DatePeriodChooserWrapper = styled.div<DatePeriodChooserWrapperProps>`
  opacity: ${({ open }) => (open ? 1 : 0)};
  align-items: stretch;
  flex-direction: column;
  justify-items: flex-start;
  min-width: 300px;
  padding: ${Spacing.S16};
  border-radius: ${DefaultValue.BorderRadius};
  position: absolute;
  top: 32px;
  right: 0px;
  z-index: 104;
  background-color: white;
  pointer-events: ${({ open }) => (open ? 'auto' : 'none')};
  ${getShadow('elevatedStrong')};
`

export const FormLabel = styled.label`
  width: 60px;
`
